"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getHeatmapGradientColorBuckets = getHeatmapGradientColorBuckets;

require("core-js/modules/es6.object.assign");

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

var _getValidObject = _interopRequireDefault(require("../../get-valid-object"));

var _hexColorToRgb = _interopRequireDefault(require("../../hex-color-to-rgb"));

var DEFAULT_BASE_COLOR = '#FFFFFF';
var BUCKET_COUNT = 10;
var INVERSE_FACTOR = 1;
var PERCENTAGE_BASE = 100;

function validRgbColor(rgbColor) {
  var checkRgbColor = (0, _getValidObject.default)(rgbColor);

  _argumentContracts.default.assertNumber(checkRgbColor.red, 'checkRgbColor.red');

  _argumentContracts.default.assertNumber(checkRgbColor.green, 'checkRgbColor.green');

  _argumentContracts.default.assertNumber(checkRgbColor.blue, 'checkRgbColor.blue');

  return Object.assign({}, checkRgbColor);
}

function getGradientColor(startRGBColor, endRGBColor, percentage) {
  var safeStartRGBColor = validRgbColor(startRGBColor);
  var safeEndRGBColor = validRgbColor(endRGBColor);

  _argumentContracts.default.assertNumber(percentage, 'percentage');

  var color = {
    red: Math.ceil(safeStartRGBColor.red * percentage + safeEndRGBColor.red * (INVERSE_FACTOR - percentage)),
    green: Math.ceil(safeStartRGBColor.green * percentage + safeEndRGBColor.green * (INVERSE_FACTOR - percentage)),
    blue: Math.ceil(safeStartRGBColor.blue * percentage + safeEndRGBColor.blue * (INVERSE_FACTOR - percentage))
  };
  return "rgb(".concat(color.red, ",").concat(color.green, ",").concat(color.blue, ")");
}

function getColorBuckets(options) {
  var safeOptions = (0, _getValidObject.default)(options);

  if (!safeOptions.seriesDataMinimumValue) {
    throw new Error("The safeOptions.seriesDataMinimumValue can't be undefined, received value: ".concat(JSON.stringify(safeOptions.seriesDataMinimumValue)));
  }

  if (!safeOptions.baseColor) {
    throw new Error("The safeOptions.baseColor can't be undefined, received value: ".concat(JSON.stringify(safeOptions.baseColor)));
  }

  if (!safeOptions.seriesColor) {
    throw new Error("The safeOptions.seriesColor can't be undefined, received value: ".concat(JSON.stringify(safeOptions.seriesColor)));
  }

  if (!safeOptions.stepSize) {
    throw new Error("The safeOptions.stepSize can't be undefined, received value: ".concat(JSON.stringify(safeOptions.stepSize)));
  }

  var seriesDataMinimumValue = safeOptions.seriesDataMinimumValue,
      baseColor = safeOptions.baseColor,
      seriesColor = safeOptions.seriesColor,
      stepSize = safeOptions.stepSize;
  var bucket = [];
  var bucketPercentageSlice = PERCENTAGE_BASE / BUCKET_COUNT;

  for (var index = 1; index < BUCKET_COUNT + 1; index++) {
    var bucketMinValue = Math.floor(seriesDataMinimumValue + stepSize * (index - 1));
    var bucketMaxValue = index !== BUCKET_COUNT ? Math.floor(seriesDataMinimumValue + stepSize * index - 1) : seriesDataMinimumValue + stepSize * index;
    bucket.push({
      color: getGradientColor(seriesColor, baseColor, index * bucketPercentageSlice / PERCENTAGE_BASE),
      min: bucketMinValue,
      max: bucketMaxValue
    });
  }

  return bucket;
}
/**
 * A function to calculate gradient colours ranges to represent seriesData
 * @param {object} options - See below
 * @param {object} options.seriesData - The seriesData
 * @param {object} options.seriesColor - The seriesColor from MwChartHeatmapOptions
 * @return {array} An array of objects with a color range detail
 */


function getHeatmapGradientColorBuckets(options) {
  var safeOptions = (0, _getValidObject.default)(options);

  _argumentContracts.default.assertArray(safeOptions.seriesData, 'safeOptions.seriesData');

  _argumentContracts.default.assertString(safeOptions.seriesColor, 'safeOptions.seriesColor');

  var seriesData = safeOptions.seriesData;
  var seriesDataValues = seriesData.map(function (point) {
    return point.value;
  });
  var seriesDataMinimumValue = Math.min.apply(null, seriesDataValues);
  var seriesDataMaximumValue = Math.max.apply(null, seriesDataValues);
  var stepSize = (seriesDataMaximumValue - seriesDataMinimumValue) / BUCKET_COUNT;
  var seriesColor = (0, _hexColorToRgb.default)(safeOptions.seriesColor);
  var baseColor = (0, _hexColorToRgb.default)(DEFAULT_BASE_COLOR);
  var seriesColorBucket = getColorBuckets({
    seriesDataMinimumValue: seriesDataMinimumValue,
    baseColor: baseColor,
    seriesColor: seriesColor,
    stepSize: stepSize
  });
  return seriesColorBucket;
}